import { makeStyles, Typography, Box } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import IVenue from "../../interfaces/IVenue";
import { HTTPMethods } from "../../yoello-lib/modules/API/API";
import APIExtensions from "../../yoello-lib/modules/API2/APIDefs";
import { useAPIV2 } from "../../yoello-lib/modules/API2/useAPIv2";
import { Loading } from "../util/ListLoading";

import { VenueViewCard } from './VenueViewCard';
import VenueViewImportButton from './VenueViewImportButton';
import Search from '../../yoello-lib/modules/components/UI/Search';
import useAcceptVenueInvitations from '../../hooks/useAcceptVenueInvitations';
import { useIsSuperuser } from '../../hooks/useIsSuperuser';
import { useVenues } from '../groupsManagement/useVenues';

interface IVenueViewListProps {
  selectedVenue: string;
  onClose: () => void;
  allowImport: boolean;
}
const useStyles = makeStyles({
  root: {
    minWidth: '500px',
    maxWidth: '550px',
    overflow: 'hidden',
  },
  venueText: {
    fontSize: '1.1rem',
    marginBottom: '1rem'
  },
  venueList: {
    height: '35vh',
    overflowX: 'auto',
    marginTop:"0.825rem"
  },
  listLoadingItem: {
    borderRadius: "0.5rem!important",
    margin: "0 1.5625rem!important",
  },
  noItems: {
    padding: "1rem",
    color: '#757575',
    fontSize: "1.05rem",
    textAlign: "center"
  }
});

export function VenueViewList({ selectedVenue, onClose, allowImport }: IVenueViewListProps) {
  const classNames = useStyles();
  const { callAPI, isLoading } = useAPIV2<IVenue[]>(APIExtensions.venueMerchant, { params: { include_disabled: true, size: 10 }, onMountDisabled: true, canAPIGetCacheValue: false });
  const [venueList, setVenueList] = useState<any[]>([]);
  const { t } = useTranslation();
  const { checkAndAcceptInvitations } = useAcceptVenueInvitations();
  const { merchant } = useIsSuperuser();
  const { venues, isLoading: isVenuesLoading, setSearchText, searchText } = useVenues();

  useEffect(() => {
    if (merchant) {
      checkAndAcceptInvitations(merchant.id).then(() => {
        callAPI(HTTPMethods.GET).then((res) => {
          if (res.isSuccessful && res.data) {
            setVenueList(res.data as IVenue[])
          }
        })
      })
    }
    //eslint-disable-next-line
  }, [merchant]);

  const onSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchText(event.currentTarget.value);
  }

  const filteredVenueList = () => {
    if (!searchText) return venueList;
    return venues
  };

  return (
    <Box data-component-name="VenueViewList" display='flex' width='100%' flexDirection='column' p={2}>
      <Typography className={classNames.venueText}>
        {venueList.length > 0 && t('venueSelection.difvenue')}
      </Typography>
      {
        venueList.length > 1 &&
        <Search
          onChange={onSearchChange}
          searchFields={[{ id: "venue-name", displayName: "Venue Name" }]}
        />
      }
      {
        allowImport &&
        <VenueViewImportButton />
      }
      <div className={classNames.venueList}>
        {isLoading || isVenuesLoading ? <Loading className={classNames.listLoadingItem} /> : filteredVenueList().length > 0 ? filteredVenueList().map((venue: IVenue, index: number) => {
          return (
              <VenueViewCard key={venue.id} venue={venue} onClose={onClose} disabled ={selectedVenue === venue.id} />
          );
        }) : <p className={classNames.noItems}>
          {t('OverviewPage.OverviewSearch.emptyList')}
        </p>}
      </div>
    </Box>
  );
}
